import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { ApiOutlined } from '@vicons/antd';
import { BuildingInsights1, Dashboard, TagEdit } from '@vicons/carbon';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.prefix 菜单名称前缀, 用于确定唯一名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const getIsMobileDeployment = () => sessionStorage.getItem('IS_MOBILE') === 'true';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/deployment',
    name: 'deployment',
    redirect: () => getIsMobileDeployment() ? '/deployment/equipment-aggregated' : '/deployment/equipment',
    component: Layout,
    meta: {
      title: 'Deployment',
      icon: renderIcon(BuildingInsights1),
      permissions: [
        'deployment_dashboard_read',
        'deployment_equipment_read',
        'deployment_move-request_read',
      ],
      sort: 4.5,
    },
    children: [
      {
        path: 'dashboard',
        name: 'deployment_dashboard',
        meta: {
          title: 'Dashboard',
          spname: 'deployment_dashboard',
          icon: renderIcon(Dashboard),
          permissions: ['deployment_dashboard_read'],
        },
        component: () => import('@/views/deployment/dashboard/index.vue'),
      },
      {
        path: 'equipment',
        name: 'deployment_equipment',
        meta: {
          title: 'Equipment',
          spname: 'deployment_equipment',
          icon: renderIcon(ApiOutlined),
          permissions: ['deployment_equipment_read'],
          hiddenWhenMobile: true,
          activeMenuWhenMobile: 'deployment_equipment-aggregated',
        },
        component: () => import('@/views/deployment/equipment/index.vue'),
      },
      {
        path: 'equipment-aggregated',
        name: 'deployment_equipment-aggregated',
        meta: {
          title: 'Equipment',
          spname: 'deployment_equipment_aggregated',
          icon: renderIcon(ApiOutlined),
          permissions: ['deployment_equipment_read'],
          hiddenWhenDesktop: true,
          activeMenu: 'deployment_equipment-aggregated',
        },
        component: () => import('@/views/deployment/equipment/AggregateView.vue'),
      },
      {
        path: 'move-request',
        name: 'deployment_move-request',
        meta: {
          title: 'Move Request',
          spname: 'deployment_move_request',
          icon: renderIcon(TagEdit),
          permissions: ['deployment_move-request_read'],
        },
        component: () => import('@/views/deployment/move-request/index.vue'),
      },
    ],
  },
];

export default routes;
